import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, message } from 'antd';
// import "./offerPrint.css"
import { useSaleRoModel } from "../saleRoModel"

import { YhOfferPrint } from "@/components/YhPrint/OfferPrint/OfferPrint"
import { saleRoService } from '../saleRoService';
import { IDetailList, ISaleRoDetail } from '../saleRoTypes';
import { numberParseChina, formatNum, fmoney } from '@/utils/utils';
import { useDictModel } from '@/views/base/dict/dictModel';
export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function SalePrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }

    const {
        salePrint: visible,
        selectedRow,
        setSalePrint,
        onPrinting,
    } = useSaleRoModel();
    const [formVal, setFormVal] = useState<ISaleRoDetail>();
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleRoService.one(selectedRow.returnCode as string);
        let { details, ...formVal } = retData;

        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }

        let newdetails: any = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            newTotal.num += Number(item.num)
            let { price, amount, discountRate, receivableAmount } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                taxPrice: formatNum(Number(price) * Number(discountRate) / 100),
                amount: fmoney(amount, 2),
                price: fmoney(price, 2),
            }
        })
        //这里做最后一行汇总信息展示
        newdetails?.push({
            workHour: newTotal.num,
            No: "",
            materialCode: "合计",
            price: fmoney(formVal.totalAmount, 2)
        })
        if (retData) {
            setMaintenanceList(newdetails as ISaleRoDetail[] ?? []);
            setFormVal(formVal)
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };

    const onCancel = () => {
        setSalePrint(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const onConfirm = async () => {
        let { id, returnCode } = selectedRow
        await onPrinting({ id, returnCode })
    }
    const columns = [
        {
            title: '序号 No',
            dataIndex: 'No',
        },
        {
            title: '编号 Code',
            dataIndex: 'materialCode',
        },
        {
            title: '名称 Name',
            dataIndex: 'materialName',
        },
        {
            title: '英文名称 NameEn',
            dataIndex: 'materialNameEn',
        },
        // {
        //     title: '规格 Specs',
        //     dataIndex: 'model',
        // },
        // {
        //     title: '产地 Origin',
        //     dataIndex: 'madeFrom',
        // },
        {
            title: '单位 Unit',
            dataIndex: 'unitName',
        },
        {
            title: '数量 Qty',
            dataIndex: 'num',
        },
        {
            title: '单价 Unit price',
            dataIndex: 'price',
        },
        {
            title: '金额 Amount',
            dataIndex: 'amount',
        },
        {
            title: '库位 Storage Bin',
            dataIndex: 'shelfCode',
        },
    ]
    const itemClumns = [
        {
            title: '序号No',
            dataIndex: 'No',
        },
        {
            title: '编号Code',
            dataIndex: 'itemCode',
        },
        {
            title: '名称Name',
            dataIndex: 'itemName',

        },
        {
            title: '英文名称NameEn',
            dataIndex: 'itemNameEn',

        },
        // {
        //     title: '规格Spec',
        //     dataIndex: 'num',
        // },
        // {
        //     title: '产地Origin',
        //     dataIndex: 'num',
        // },
        {
            title: '单位Unit wu',
            dataIndex: 'unitName',
        },
        {
            title: '数量Num',
            dataIndex: 'workHour',
        },
        {
            title: '单价Unit price',
            dataIndex: 'price',
        },
        {
            title: '金额Sum',
            dataIndex: 'amount',
        },
        {
            title: '备注Note',
            dataIndex: 'note',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "销往单位 Customer name：",
                fieldValue: formVal?.customerName,
                className: "header-flex5"
            },
            {
                fieldLabel: "电话 Tel：",
                fieldValue: formVal?.phone,
                // className: "header-flex6"
                className: "header-flex5"

            },
            {
                fieldLabel: "销售单号 SaleNo：",
                fieldValue: formVal?.returnCode
            },
            {
                fieldLabel: "销售日期 Sales date：",
                fieldValue: formVal?.createTime
            },
            {
                fieldLabel: "第1/1页",
                fieldValue: ""
            },
        ],
        footer: [
            {
                fieldLabel: "地址 Address：",
                fieldValue: formVal?.address
            },
            {
                fieldLabel: "电话 Tel：",
                fieldValue: formVal?.phone
            },
        ],
        footerPeople: [
            {
                fieldLabel: "开单 Operator：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "业务员 Salesman：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "财务 Financial：",
                fieldValue: formVal?.reckoner
            },
            {
                fieldLabel: "仓库 Warehouse：",
                fieldValue: maintenanceList[0]?.warehouseName
            },
            {
                fieldLabel: "收货 Receiver：",
                fieldValue: formVal?.customerName
            },

        ],
        note: {
            fieldLabel: "备注 Remark：",
            fieldValue: formVal?.note
        },
        Total: [
            {
                fieldLabel: "大写金额 THE SUM OF：",
                fieldValue: numberParseChina(formVal?.totalAmount as string)
            },
            {
                fieldLabel: "结算方式 Payment Type：",
                fieldValue: getTreeNodeName(formVal?.payType as string)
            },
        ],
        Total1: [
            {
                fieldLabel: "去零 Favorable Amount：",
                fieldValue: ""
            },
            {
                fieldLabel: "合计金额 Total：",
                fieldValue: fmoney(formVal?.totalAmount, 2)
            },
        ]
    }
    const headerTitle = {
        titleEn: "Asia-Africa International FZE",
        title: "销售清单 SaleBill"
    }
    return (
        <YhOfferPrint
            title="销售单打印详情"
            type=""
            visible={visible}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            dataSource={maintenanceList}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
    // return <Modal
    //     title="报价单打印详情"
    //     width={1200}
    //     visible={visible}
    //     onCancel={onClose}
    //     footer={[
    //         // <Button type="link" onClick={onClose} key="back"> 取消</Button>,
    //         // <Button type="link" onClick={print} key="submit">确认打印</Button>,
    //         // <Button type="link" onClick={setTitle} key="setPrintName">设置</Button>
    //     ]}
    // >
    //     <div className="offerPrint-container">
    //         <div className="title">
    //             <h2>Asia-Africa International FZE</h2>
    //             <h2>报价单</h2>
    //         </div>
    //         <ul className="header">
    //             {/* <li>报价单位：个体</li> */}
    //             <li>报价单号：BJ20210218005</li>
    //             <li>制单员：董英</li>
    //             <li>第1/1页</li>
    //             <li>合计金额：600000</li>
    //         </ul>
    //         <table className="mingxi">
    //             <tbody>
    //                 <tr className="print-center">
    //                     <td>序号 NO.</td>
    //                     <td>编号 Serial number</td>
    //                     <td>名称 name</td>
    //                     <td>规格 SPEC</td>
    //                     <td>产地 FORM</td>
    //                     <td>单位 unit</td>
    //                     <td>数量 amount</td>
    //                     <td>单价 unit price</td>
    //                     <td>金额 sum</td>
    //                     <td>备注 note</td>
    //                 </tr>
    //                 <tr className="print-center">
    //                     <td>1</td>
    //                     <td>SJK00810</td>
    //                     <td>水泵</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                     <td>无</td>
    //                 </tr>
    //             </tbody>
    //         </table>
    //         <div className="footer">
    //             <p>地址：尼日利亚修理厂</p>
    //             <p>电话：18735420144</p>
    //             <p>备注：我来修车了</p>
    //         </div>
    //         {/* <ul className="footer">
    //             <li>报价单号：BJ20210218005</li>
    //             <li>制单员：董英</li>
    //             <li>第1/1页</li>
    //             <li>合计金额：600000</li>
    //         </ul> */}
    //     </div>
    // </Modal>
}